import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

export const Route = createFileRoute('/_app/faqs')({
  component: FAQsPage,
  beforeLoad: () => {
    return {
      noContainer: true,
      pageBackground: 'white',
    };
  },
});

function FAQsPage() {
  const { t } = useTranslation();
  return (
    <PageContainer>
      <HeroSection>
        <HeroImage src="https://picsum.photos/2500/500?random=102" />
        <ContentContainer>
          <PageTitle>{t('navigation.faq')}</PageTitle>
          {/* Translation Needed - all FAQ questions and answers below */}
          <FAQContainer>
            <FAQItem>
              <Question>What is a WBS "study helper"?</Question>
              <Answer>
                A WBS study helper is a Christian friend who is available to
                help you understand the Bible as you take the WBS courses. WBS
                study helpers are everyday people like you and me who volunteer
                their time to help others. Your study helper will exchange
                lessons with you, review your lesson answers and give you
                feedback, help you find Scriptures to answer your personal
                questions, and be available as a prayer partner.
              </Answer>
            </FAQItem>

            <FAQItem>
              <Question>What are the WBS Courses?</Question>
              <Answer>
                WBS offers a core set of lesson booklets and online lessons
                known as the Master Series. The Bible-based lessons teach the
                fundamentals of God, His grace and love, Jesus, the Gospel
                message, the church, and Christian living. WBS courses are
                designed to increase your knowledge and faith in God by seeing
                for yourself what the Bible says.
              </Answer>
            </FAQItem>

            <FAQItem>
              <Question>
                The World Bible School Courses – The Master Series
              </Question>
              <Answer>
                <CourseSection>
                  <CourseTitle>
                    Introduction Lesson – "The Way to Life" A brief one-lesson
                    introduction
                  </CourseTitle>
                  <CourseDescription>
                    The Bible is relevant to human kind, presenting God to man.
                    How did we get the Bible? Is it trustworthy? Does it apply
                    to me, today? What is the "Good News" of the Bible?
                  </CourseDescription>
                </CourseSection>

                <CourseSection>
                  <CourseTitle>"God Has Spoken" 8 lessons</CourseTitle>
                  <CourseDescription>
                    God reveals Himself and His will for you in the Bible. What
                    does God say about Himself? Who is the Holy Spirit? How can
                    I be "right with God"?
                  </CourseDescription>
                </CourseSection>

                <CourseSection>
                  <CourseTitle>This is Good News! 7 lessons</CourseTitle>
                  <CourseDescription>
                    God's message in the Bible is "good news"! How does God want
                    me to respond to it? What is faith that "saves"? How can I
                    be sure about my faith? What do I receive from God's good
                    news?
                  </CourseDescription>
                </CourseSection>

                <CourseSection>
                  <CourseTitle>Knowing Jesus 7 lessons</CourseTitle>
                  <CourseDescription>
                    Jesus makes remarkable promises to those who "know" Him. How
                    can I know Jesus? What do prophets and eye-witnesses say
                    about Him? Is Jesus God's Son? Why did He die? Is He alive
                    today?
                  </CourseDescription>
                </CourseSection>

                <CourseSection>
                  <CourseTitle>Born of Water and Spirit 8 lessons</CourseTitle>
                  <CourseDescription>
                    Jesus speaks of being "born again" to live a new life. What
                    does He mean? Can I really have a fresh start in life? Why
                    is the cross so important? How can I face death with
                    assurance?
                  </CourseDescription>
                </CourseSection>

                <CourseSection>
                  <CourseTitle>
                    The Family of God 8 lessons, plus extensive study helps
                  </CourseTitle>
                  <CourseDescription>
                    God has chosen a family of His very own—and He wants you to
                    be a part of it. Who has God chosen? Me? How can I know?
                    What does the word "church" really mean? What is His purpose
                    for my life?
                  </CourseDescription>
                </CourseSection>

                <CourseSection>
                  <CourseTitle>
                    Live a Life of Love 13 lessons, plus extensive study helps
                  </CourseTitle>
                  <CourseDescription>
                    God offers every single person a new purpose and a joyful
                    life. How does He want me to live? Can I really change? Is
                    the Holy Spirit real-and really at work in my life? How can
                    I help others?
                  </CourseDescription>
                </CourseSection>
              </Answer>
            </FAQItem>

            <FAQItem>
              <Question>Will WBS charge me for taking Bible courses?</Question>
              <Answer>
                No. WBS lessons are free of charge. The expenses for WBS are
                provided by the generous donations of Christians who care. They
                have a strong desire for students to increase their faith in
                God, and hear the Good News of the Bible.
              </Answer>
            </FAQItem>

            <FAQItem>
              <Question>Who is behind WBS?</Question>
              <Answer>
                <p>
                  WBS is a ministry of the churches of Christ. With no
                  denominational affiliation, the churches of Christ seek simply
                  to be New Testament Christians who joyfully call all people to
                  be one in Christ. Christians that support WBS believe that:
                </p>
                <ul>
                  <li>
                    we should follow the Bible only, not human doctrines or
                    opinions;
                  </li>
                  <li>
                    nothing should be required of people as acts of faith except
                    that which is evident in the Bible;
                  </li>
                  <li>
                    Jesus Christ lived, died, resurrected, and lives today for
                    those who believe in Him, so that they can have hope, joy,
                    love, and life.
                  </li>
                  <li>
                    with the Bible as our guide, we should seek to restore the
                    original church of Christ as found in the Bible's New
                    Testament.
                  </li>
                  <li>
                    We believe the Bible alone must serve as the basis for all
                    religious teaching and that all authority in the church
                    belongs to Christ. We are not a denomination, but simply
                    Christians that belong to the "body" of believers of which
                    Christ is the "head". We plead for religious unity among all
                    believers based on the Bible.
                  </li>
                </ul>
              </Answer>
            </FAQItem>

            <FAQItem>
              <Question>
                What are the options for studying WBS courses?
              </Question>
              <Answer>
                WBS courses are available by:
                <ul>
                  <li>printed booklets that are exchanged by postal mail;</li>
                  <li>online, Web-based lessons.</li>
                </ul>
              </Answer>
            </FAQItem>

            <FAQItem>
              <Question>Are WBS courses available in other languages?</Question>
              <Answer>
                Yes. The WBS courses are available online and in print for
                postal mail in the following languages: French, Spanish and
                Portuguese.
              </Answer>
            </FAQItem>

            <FAQItem>
              <Question>Is WBS an accredited school or university?</Question>
              <Answer>
                WBS is not an accredited institution and does not offer diplomas
                or degrees. It is a way that one can learn about the message of
                the Bible for themselves.
              </Answer>
            </FAQItem>

            <FAQItem>
              <Question>Does WBS have a campus in the U.S.?</Question>
              <Answer>
                No. WBS is a "distance learning" school that uses mailed or
                Web-based lesson.
              </Answer>
            </FAQItem>

            <FAQItem>
              <Question>What are the benefits of studying with WBS?</Question>
              <Answer>
                The Bible offers benefits and blessings to each and every
                person. Hope, joy, love, and life are available to all. In fact,
                the Bible is the only true source of life's most important
                truths and blessings. Find out more by enrolling and taking the
                brief introduction lesson, The Way to Life. WBS courses will
                benefit you as you see what the Bible's message is, increase
                your knowledge of God and Jesus, enrich your personal and
                spiritual life, and build a firm foundation for yourself based
                on God's Word.
              </Answer>
            </FAQItem>

            <FAQItem>
              <Question>
                How long does it take to complete WBS courses?
              </Question>
              <Answer>
                WBS courses are written for busy people. Each lesson within a
                course is brief and can be completed at your own pace, perhaps
                in about 30 minutes. In the seven courses of the WBS Master
                Series, there are 55 lessons. There is no time pressure for
                completing the lessons and you should proceed with the idea of
                "just one lesson at a time." Web-based lessons can, obviously,
                be completed much more quickly than those exchanged using postal
                mail around the world.
              </Answer>
            </FAQItem>

            <FAQItem>
              <Question>Will WBS send me a free Bible?</Question>
              <Answer>
                No. However, all Bible passages are included in the lessons so
                that access to a Bible is not necessary to complete them. A good
                site for online Bibles and study resources is
                www.biblegateway.com. After you have proven your commitment by
                completing a number of WBS lessons, some study helpers help
                their students acquire a Bible of their own.
              </Answer>
            </FAQItem>
          </FAQContainer>
        </ContentContainer>
      </HeroSection>
    </PageContainer>
  );
}

const PageContainer = styled.div`
  min-height: 100vh;
  width: 100%;
`;

const HeroSection = styled.section`
  min-height: 900px;
  overflow: hidden;
  padding: 230px 158px 0;
  position: relative;
`;

const HeroImage = styled.img`
  height: 580px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 0;
`;

const ContentContainer = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  position: relative;
  z-index: 1;
`;

const PageTitle = styled.h1`
  color: var(--white);
  font-size: 35px;
  font-weight: 600;
  margin-bottom: 56px;
  text-align: center;
`;

const FAQContainer = styled.div`
  background-color: var(--white);
  border-radius: 8px;
  padding: 49px 40px 40px 50px;
  position: relative;
  z-index: 2;
`;

const FAQItem = styled.div`
  margin-bottom: 21px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Question = styled.h3`
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 30px 0;
`;

const Answer = styled.div`
  color: var(--grey-800);
  font-size: 16px;
  line-height: 1.7;

  ul {
    letter-spacing: 0.7px;
    margin: 17px 0 28px;
    padding-left: 26px;
  }
`;

const CourseSection = styled.div`
  margin: 0 0;
`;

const CourseTitle = styled.h4`
  color: var(--grey-900);
  font-size: 18px;
  font-weight: 400;
  margin: 20px 0 21px 0;
`;

const CourseDescription = styled.p`
  color: var(--grey-700);
  font-size: 15px;
  letter-spacing: 0.46px;
  line-height: 1.8;
`;
